var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ts-loading-banner',{attrs:{"loading":_vm.loading}},[_c('div',{staticClass:"view-account"},[_c('section',{staticClass:"module"},[_c('div',{staticClass:"module-inner"},[(!_vm.loading)?_c('folder-tree',{attrs:{"data":_vm.data},on:{"fetchNavi":_vm.fetch}}):_vm._e(),_c('content-panel',{ref:"contentPanel",on:{"fetchNavi":_vm.fetch}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }